import VimeoPlayerScroll from '../../../utils/vimeo-player.js';

export default class XLTileVimeoPlayer {
    constructor(el) {
        this.el = el.querySelector('.xl-tile-lite-vimeo-player');
        this.index = [...document.querySelectorAll('.xl-tile-lite-vimeo-player')].indexOf(this.el);
        this.vimeoDefaultOptions = {
            autoplay: false,
            autopause: true,
            background: true,
            dnt: true,
        };
        this.el.setAttribute('id', `vimeo-player-${this.index}`);
        this.init();
    }

    init() {
        const { videoUrl } = this.el.dataset;
        const videoOptions = { ...this.vimeoDefaultOptions, url: videoUrl };
        const videoPlayer = new VimeoPlayerScroll(this.el.getAttribute('id'), videoOptions);
        videoPlayer.on('loaded', () => this.loaded());
        videoPlayer.ready().catch(() => this.loaded());
    }

    loaded() {
        try {
            this.el.dispatchEvent(new CustomEvent('VimeoLoaded'));
        } catch (e) {
            console.error(e);
        }
    }
}
